import './CounterLabel-8c6e8ee4.css';

var classes = {"CounterLabel":"prc-CounterLabel-CounterLabel-ZwXPe"};

export { classes as default };
